<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <span class="panel-title">
          <i class="fa fa-dollar-sign"></i>
          Rate Management
        </span>
        <button class="btn-back" @click="$router.push({ name: 'admin.serviceprovider.index' })">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>

      <!-- Tabs (admin only) -->
      <div class="tab-bar" v-if="currentUser.u.is_admin == 1">
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'fdle' }"
          @click="active_tab = 'fdle'"
        >
          <i class="fa fa-map-marker-alt"></i> Florida (FDLE)
        </button>
        <button
          class="tab-btn"
          :class="{ active: active_tab === 'spsc' }"
          @click="active_tab = 'spsc'"
        >
          <i class="fa fa-fingerprint"></i> Service Codes
        </button>
      </div>

      <!-- Tab content -->
      <v-fdle-rates v-if="active_tab === 'fdle'"></v-fdle-rates>
      <v-fingerprint-rates v-else></v-fingerprint-rates>

    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import vFdleRates from "@/pages/backend/serviceprovider/serviceorirates/fdlerates";
import vFingerprintRates from "@/pages/backend/serviceprovider/serviceorirates/fingerprintrate";

export default {
  components: { vFdleRates, vFingerprintRates },
  data() {
    return {
      active_tab: "fdle",
      breadCrumbs: [
        { id: 1, title: "Dashboard",         route: "admin.dashboard" },
        { id: 2, title: "Service Providers", route: "admin.serviceprovider" },
        { id: 3, title: "Rates",             route: "" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;
  border-radius: 12px 12px 0 0;

  .panel-title {
    font-size: 13px;
    font-weight: 700;
    color: $blue;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .btn-back {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    padding: 0 14px;
    background: #fff;
    color: #4a5568;
    border: 1.5px solid $border;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: all 0.15s;

    &:hover { border-color: $blue; color: $blue; }
  }
}

.tab-bar {
  display: flex;
  border-bottom: 2px solid #eef0f8;
  padding: 0 20px;
  gap: 4px;
  background: #fafbfd;
}

.tab-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 42px;
  padding: 0 18px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  color: #7a8499;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s, border-color 0.15s;

  i { font-size: 12px; }

  &:hover { color: $blue; }

  &.active {
    color: $blue;
    border-bottom-color: $blue;
  }
}
</style>
